export default __webpack_public_path__ + "assets/ico_no_contract-1a42a93c.svg";